import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { routesConfig } from "../../config/routes";
import { ProductCategory } from "../../shared/enums/ProductCategory";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { cookies } from "../../shared/helpers/cookies";
import { action } from "../../store/action";
import { useCartProduct } from "../../store/hooks/useCartProduct";
import { useCartSelectionsProduct } from "../../store/hooks/useCartSelectionsProduct";
import { useMachineTonnage } from "../../store/hooks/useMachineTonnage";
import { useProduct } from "../../store/hooks/useProduct";
import Product from "../Products/Product";
import DisclamerText from "../shared/DisclamerText";
import WizardContainer from "./Container/WizardContainer";
import "./ProductStep.scss";

const ProductStep = () => {
  const dispatch = useDispatch();
  const { machineFixingType, productCategory, toolsProductTypes } =
    useProduct();
  const cartProduct = useCartProduct();
  const cartSelectionsProduct = useCartSelectionsProduct();
  const { t } = useTranslation("productstep");
  const machineTonnage = useMachineTonnage();
  const cookieMarket = cookies.getMarket();

  useEffect(() => {
    if (!machineTonnage) {
      const routeMarket = cookieMarket ? cookieMarket : "en";
      window.location.href = routesConfig[routeMarket].machineTonnageStep;
    }
  }, [cookieMarket, machineTonnage]);

  useEffect(() => {
    if (!cartSelectionsProduct && cartProduct) {
      dispatch(action.copyCartProductToCartProductSelections());
    }
  }, [cartProduct, cartSelectionsProduct, dispatch]);

  useEffect(() => {
    if (!cartSelectionsProduct) {
      const enableNext = false;
      dispatch(
        action.saveWizard({
          activeStepIndex: WizardStepIndex.Product,
          enableNext,
        })
      );
      return;
    }

    if (productCategory === ProductCategory.Tiltrotator) {
      const enableNext =
        cartSelectionsProduct.grappleModule ||
        cartSelectionsProduct.isNoneGrappleModuleSelected
          ? true
          : false;

      dispatch(
        action.saveWizard({
          activeStepIndex: WizardStepIndex.Product,
          enableNext,
        })
      );
      return;
    }

    if (productCategory === ProductCategory.MachineFixings) {
      const enableNext = cartSelectionsProduct.machineFixing ? true : false;

      dispatch(
        action.saveWizard({
          activeStepIndex: WizardStepIndex.Product,
          enableNext,
        })
      );
      return;
    }

    if (productCategory === ProductCategory.Tools) {
      const enableNext =
        cartSelectionsProduct.toolsProductItems &&
        cartSelectionsProduct.toolsProductItems.length > 0
          ? true
          : false;

      dispatch(
        action.saveWizard({
          activeStepIndex: WizardStepIndex.Product,
          enableNext,
        })
      );
      return;
    }
  }, [dispatch, cartSelectionsProduct, productCategory]);

  useEffect(() => {
    dispatch(action.saveIsLoadedFromSummary(false));
  }, [dispatch]);

  return (
    <WizardContainer>
      <div>
        <div className="desktopWidth">
          <h1>{t("producttexts.productheading")}</h1>
          <div>
            <p>{t("producttexts.productintro")}</p>
          </div>
        </div>

        <Product
          isNoneGrappleModuleSelected={
            cartSelectionsProduct?.isNoneGrappleModuleSelected
          }
          selectedGrappleModule={cartSelectionsProduct?.grappleModule}
          selectedMachineFixingType={machineFixingType}
          selectedMachineFixing={cartSelectionsProduct?.machineFixing}
          selectedLowerBracket={cartSelectionsProduct?.lowerBracket}
          selectedProductCategory={productCategory}
          selectedTiltrotator={cartSelectionsProduct?.tiltrotator}
          selectedToolsProductItems={cartSelectionsProduct?.toolsProductItems}
          selectedToolsProductTypes={toolsProductTypes}
          selectedUpperBracket={cartSelectionsProduct?.upperBracket}
        />
        <div>
          <DisclamerText />
        </div>
      </div>
    </WizardContainer>
  );
};

export default ProductStep;
